import { Seo } from 'components'

import { TechPageTemplate } from '../template'

export const TechWorksPage = () => (
  <>
    <Seo
      description="На сервисе грузоперевозок QP5 Express проводятся технические работы, в ближайшее время мы вернемся к вам."
      title="Технические работы"
    />
    <TechPageTemplate
      text="Приносим извинения за доставленные неудобства. Мы возобновим работу сегодня в 02:00 по Москве."
      title="Работа сайта приостановлена на техническое обслуживание"
      icon={
        <div
          className="mb-5 flex h-[116px] w-[116px] items-center justify-center rounded-full text-[48px] text-on-primary md:mb-10"
          data-test-id="tech--works--page"
        >
          <svg fill="none" height="108" viewBox="0 0 108 108" width="108" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M104.2 41.4C103.6 42.6 102.8 43.6 101.8 44.6C103.4 47.6 104.6 50.8 105.4 54L101.4 56.4C98.8 54.2 96.6 51.6 94.8 48.8C93.4 49.2 92 49.4 90.4 49.4C89.2 52.2 88 55 86.6 58.6L82.2 57.4C82.3546 55.9314 82.4793 54.5823 82.5973 53.3065C82.7844 51.2815 82.9546 49.4403 83.2 47.6C81.8 46.8 80.6 46 79.4 44.8C76.6 46 73.8 47.2 70.2 48.6L68 44.6C68.8948 43.8842 69.7362 43.2039 70.5402 42.5539L70.5415 42.5529C72.4324 41.0241 74.1162 39.6628 75.8 38.4C75.4 37 75.2 35.4 75.2 33.8C72.4 32.6 69.6 31.4 66 30L67.2 25.6C68.7249 25.7605 70.1531 25.8888 71.5106 26.0108C73.5359 26.1927 75.4039 26.3605 77.2 26.6C78 25.2 78.8 24 80 22.8C78.8 20 77.6 17.2 76.2 13.6L80.2 11.2C80.9163 12.0954 81.5969 12.9373 82.2473 13.7417C83.776 15.6326 85.1372 17.3163 86.4 19C87.8 18.6 89.2 18.4 90.8 18.4C91 17.9001 91.1499 17.4002 91.2999 16.9003C91.4499 16.4002 91.6 15.9 91.8 15.4C81.8 5.8 68.6 0 54 0C35 0 18.4 9.6 8.8 24.4L9.8 24C12 26.2 14 28.6 15.6 31.2C17.4 30.6 19.2 30 21.2 29.6C21.2 26.6 21.4 23.4 21.8 20.4L25.8 20C27 22.8 28 25.8 28.8 28.8C30.6321 28.8 32.2964 28.9678 34.1004 29.1498L34.6 29.2C35.6 26.4 37 23.6 38.4 20.8L42.4 21.8C42.6 24.8 42.6 28 42.2 31C44 31.6 45.7999 32.4 47.5999 33.1999C49.5999 30.7999 51.8 28.6 54.2 26.8L57.6 29C56.8 32 55.6 34.8 54.2 37.6C55.8 38.8 57.2 40.2 58.4 41.6C61.2 40 64 38.8 66.8 37.8L69.2 41C67.4 43.4 65.2 45.8 63 47.8C64 49.4 65 51.2 65.6 53C68.6 52.4 71.8 52.2 75 52.2L76.2 56C73.6 57.6 70.8 59 68 60.2C68.3639 61.8376 68.5623 63.6408 68.7457 65.3084C68.7639 65.4737 68.782 65.6376 68.8 65.8C72 66.4 75 67.2 78 68.2L77.8 72.2C74.8 72.8 71.6 73.2 68.6 73.4C68.4601 74.6592 68.1244 76.0163 67.7984 77.3343C67.6585 77.9001 67.5201 78.4594 67.4 79C70.2 80.6 72.8 82.4 75.2 84.4L73.6 88C70.4 87.6 67.4 87 64.4 86C64.2 86.4 63.95 86.8 63.7 87.2C63.45 87.6 63.2 88 63 88.4C62.4001 89.1999 61.7999 90.0001 61.4 90.6C63.4 93 65.2 95.6 66.8 98.2L64 101C61.2 99.6 58.6 98 56 96C54.6 97.2 53 98.4 51.4 99.4C52.4 102.2 53.2 105 53.8 108H54.2C84 108 108.2 83.8 108.2 54C108.2 49.8 107.8 45.8 106.8 41.8C105.8 41.8 105 41.6 104.2 41.4Z"
              fill="#2658A6"
            />
            <path
              d="M88.8 41.2C84.6 40.2 82.2 36 83.2 31.8C84.2 27.6 88.4 25.2 92.6 26.2C96.8 27.2 99.2 31.4 98.2 35.6C97.2 39.8 93 42.2 88.8 41.2Z"
              fill="#2658A6"
            />
            <path
              d="M47.8 40C44 37.6 40 36 35.8 35.2L34.8 53.2C36 53.6 37 54 38 54.8C44 58.6 46.4 66 43.8 72.6L59 82.4C66.8 67.6 62 49 47.8 40Z"
              fill="#2658A6"
            />
            <path
              d="M57.8 84.4L57.4 85V84.8C57.4764 84.7236 57.5236 84.6472 57.5639 84.582C57.6292 84.4764 57.6764 84.4 57.8 84.4Z"
              fill="#2658A6"
            />
            <path
              d="M4.2 38C5.6 36.8 7.2 35.6 8.8 34.6C8 32.4 7.4 30.2 6.8 27.8C5.2 30.8 3.8 33.8 2.8 37C3.02462 37.1123 3.24924 37.2877 3.50928 37.4907C3.71231 37.6492 3.93693 37.8246 4.2 38Z"
              fill="#2658A6"
            />
            <path
              d="M44.2 102.8C45.4 104.4 46.6 106 48 107.6C44.8 107.2 41.6 106.6 38.6 105.8V104.4C40.6 104 42.4 103.4 44.2 102.8Z"
              fill="#2658A6"
            />
            <path
              d="M55.6 87L40.4 77.2L40 77.6C34 83.2 24.6 82.8 19 76.8L8 82.4C12 88.8 17.4 94.4 23.6 98.6C35.4 101 47.8 96.8 55.6 87Z"
              fill="#2658A6"
            />
            <path
              d="M2.3 49.4C2.35 49.35 2.4 49.3 2.4 49.2C8.8 39.6 19.2 34.6 29.8 34.8L28.8 52.4C24.2 52.6 20 55 17.4 58.8C15 62.6 14.4 67.4 16 71.8L5.2 77.2C1.8 70.2 0 62.4 0 54V53.6C0.437051 52.5802 0.98022 51.6665 1.55221 50.7044C1.76547 50.3457 1.98273 49.9802 2.2 49.6C2.2 49.5 2.25 49.45 2.3 49.4Z"
              fill="#2658A6"
            />
            <path
              d="M25 63.6C26.8 61 30.4 60.2 33.2 62C36 63.8 36.8 67.4 35 70C33.2 72.6 29.6 73.4 26.8 71.6C24 70 23.2 66.4 25 63.6Z"
              fill="#2658A6"
            />
          </svg>
        </div>
      }
    />
  </>
)
